@if (!isLoaded) {
  <lin-spinner></lin-spinner>
}

@if (formError) {
  <div class="lin-form-error">{{ formError }}</div>
}

@if (isLoaded) {
  <form lin-layout-form [formGroup]="form" (ngSubmit)="saveData()">
    <lin-layout-form-sections-wrapper>
      <lin-layout-form-section layout="triple">
        <lin-form-label [required]="required.has('name')">{{ 'FIELDS.COMPANY_NAME' | translate }}:</lin-form-label>
        <mat-form-field color="accent">
          <input matInput formControlName="name" autocomplete="off" />
          <mat-error>
            <lin-form-field-error [control]="form.get('name')" controlName="name"></lin-form-field-error>
          </mat-error>
        </mat-form-field>

        <lin-form-label [required]="required.has('legalName')">{{ 'FIELDS.LEGAL_NAME' | translate }}:</lin-form-label>
        <mat-form-field>
          <input matInput formControlName="legalName" autocomplete="off" />
          <mat-error>
            <lin-form-field-error [control]="form.get('legalName')" controlName="legalName"></lin-form-field-error>
          </mat-error>
        </mat-form-field>

        <lin-form-label [required]="required.has('taxNr')">{{ 'FIELDS.ABN' | translate }}:</lin-form-label>
        <mat-form-field>
          <input matInput formControlName="taxNr" autocomplete="off" />
          <mat-error>
            <lin-form-field-error [control]="form.get('taxNr')" controlName="taxNr"></lin-form-field-error>
          </mat-error>
        </mat-form-field>

        @if (showChevronAccountId) {
          <lin-form-label [required]="true">{{ 'FIELDS.chevronAccountId' | translate }}:</lin-form-label>
          <mat-form-field>
            <input matInput formControlName="chevronAccountId" autocomplete="off" />
            <mat-error>
              <lin-form-field-error [control]="form.get('chevronAccountId')" controlName="chevronAccountId"></lin-form-field-error>
            </mat-error>
          </mat-form-field>
        }

        <lin-form-label [required]="required.has('legalAddress')">{{ 'FIELDS.LEGAL_ADDRESS' | translate }}: </lin-form-label>
        <mat-form-field>
          <textarea class="textarea" matInput rows="2" formControlName="legalAddress"></textarea>
          <mat-error>
            <lin-form-field-error [control]="form.get('legalAddress')" controlName="legalAddress"></lin-form-field-error>
          </mat-error>
        </mat-form-field>

        <lin-form-label [required]="required.has('billingAddress')">{{ 'FIELDS.BILLING_ADDRESS' | translate }}: </lin-form-label>
        <mat-form-field>
          <textarea class="textarea" matInput rows="2" formControlName="billingAddress"></textarea>
          <mat-error>
            <lin-form-field-error [control]="form.get('billingAddress')" controlName="billingAddress"></lin-form-field-error>
          </mat-error>
        </mat-form-field>

        @if (reseller) {
          <lin-form-label [required]="required.has('keyContact')">{{ 'FIELDS.KEY_CONTACT' | translate }}:</lin-form-label>
          <mat-form-field>
            <mat-select formControlName="keyContact" data-testid="select-key-contact">
              <mat-option value=""></mat-option>
              @for (user of resellerUsers; track user.id) {
                <mat-option [value]="user.id">{{ user.name + ' ' + user.surname }}</mat-option>
              }
            </mat-select>
            <mat-icon svgIcon="mail_outline" (click)="sendEmail($event, 'keyContact')" matSuffix></mat-icon>
            <mat-error>
              <lin-form-field-error [control]="form.get('keyContact')" controlName="keyContact"></lin-form-field-error>
            </mat-error>
          </mat-form-field>
        }
      </lin-layout-form-section>

      <lin-layout-form-section layout="triple">
        <lin-form-label [required]="required.has('status')">
          <span>{{ 'FIELDS.STATUS' | translate }}:</span>
          @if (resellerId) {
            <a (click)="getStatusHistory()">{{ 'FIELDS.STATUS_INFO' | translate }}</a>
          }
        </lin-form-label>
        <mat-form-field>
          <mat-select formControlName="status" data-testid="select-status">
            @for (status of formStatuses; track status.name) {
              <mat-option [value]="status.name" [disabled]="status.disabled">
                {{ status.displayName }}
              </mat-option>
            }
          </mat-select>
          <mat-error>
            <lin-form-field-error [control]="form.get('status')" controlName="status"></lin-form-field-error>
          </mat-error>
        </mat-form-field>

        @if (form.value.status === 'demo') {
          <lin-form-label [required]="required.has('expirationDate')">{{ 'FIELDS.expirationDate' | translate }}: </lin-form-label>

          <lin-datepicker-field formControlName="expirationDate" [isPlaceholderShown]="true" [isNoMaxDate]="true"> </lin-datepicker-field>
        }

        <lin-form-label>{{ 'FIELDS.SALES_REPRESENTATIVE' | translate }}:</lin-form-label>
        @if (user.isAdmin()) {
          <mat-form-field>
            <mat-select formControlName="salesRepresentative" data-testid="select-sales-representative">
              <mat-option value=""></mat-option>
              @for (manager of salesRepresentatives; track manager.id) {
                <mat-option [value]="manager.id">{{ manager.fullName }}</mat-option>
              }
            </mat-select>
            <mat-error>
              <lin-form-field-error [control]="form.get('salesRepresentative')" controlName="salesRepresentative"></lin-form-field-error>
            </mat-error>
          </mat-form-field>
        } @else {
          <mat-form-field>
            <input matInput formControlName="salesRepresentative" autocomplete="off" />
            <mat-error>
              <lin-form-field-error [control]="form.get('salesRepresentative')" controlName="salesRepresentative"></lin-form-field-error>
            </mat-error>
          </mat-form-field>
        }

        <lin-form-label>{{ 'FIELDS.ACCOUNT_MANAGER' | translate }}:</lin-form-label>
        @if (user.isAdmin()) {
          <mat-form-field>
            <mat-select formControlName="accountManager" data-testid="select-account-manager">
              <mat-option value=""></mat-option>
              @for (manager of accountManagers; track manager.id) {
                <mat-option [value]="manager.id">{{ manager.fullName }}</mat-option>
              }
            </mat-select>
            <mat-error>
              <lin-form-field-error [control]="form.get('accountManager')" controlName="accountManager"></lin-form-field-error>
            </mat-error>
          </mat-form-field>
        } @else {
          <mat-form-field>
            <input matInput formControlName="accountManager" autocomplete="off" />
            <mat-error>
              <lin-form-field-error [control]="form.get('accountManager')" controlName="accountManager"></lin-form-field-error>
            </mat-error>
          </mat-form-field>
        }

        <lin-form-label [required]="required.has('timezone')">{{ 'FIELDS.TIMEZONE' | translate }}:</lin-form-label>
        <mat-form-field>
          <lin-form-timezone-select formControlName="timezone" [timezones]="timezones"></lin-form-timezone-select>
          <mat-error>
            <lin-form-field-error [control]="form.get('timezone')" controlName="timezone"></lin-form-field-error>
          </mat-error>
        </mat-form-field>

        <lin-language-field formControlName="language"></lin-language-field>
      </lin-layout-form-section>

      <lin-layout-form-section layout="triple">
        @if (resellerId) {
          <lin-note-list
            [isClient]="!!resellerId"
            [notesHistory]="resellerNotesHistory"
            (addNewNote)="addNote('reseller', $event)"
            (deleteNote)="deleteNote($event)"
          ></lin-note-list>

          @if (user.isAdmin()) {
            <lin-note-list
              [isClient]="!!resellerId"
              [noteText]="'FIELDS.ADMIN_NOTE_TEXT' | translate"
              [notesHistory]="adminNotesHistory"
              (addNewNote)="addNote('admin', $event)"
              (deleteNote)="deleteNote($event)"
              [style.margin-top.px]="'15'"
            ></lin-note-list>
          }
        } @else {
          <lin-form-label [required]="required.has('resellerNote')">
            <span>{{ 'FIELDS.ADD_NEW_NOTE' | translate }} {{ (user.isAdmin() && ('FIELDS.NOTE_TEXT' | translate)) || '' }}:</span>
            @if (resellerId) {
              <a (click)="getResellerNotes()">{{ 'FIELDS.NOTES_HISTORY' | translate }}</a>
            }
          </lin-form-label>
          <mat-form-field>
            <textarea matInput matTextareaAutosize matAutosizeMinRows="7" matAutosizeMaxRows="7" formControlName="resellerNote"></textarea>
            <mat-error>
              <lin-form-field-error [control]="form.get('resellerNote')" controlName="resellerNote"></lin-form-field-error>
            </mat-error>
          </mat-form-field>

          @if (user.isAdmin()) {
            <lin-form-label [required]="required.has('adminNote')">
              <span>{{ 'FIELDS.ADD_NEW_NOTE' | translate }} {{ (user.isAdmin() && ('FIELDS.ADMIN_NOTE_TEXT' | translate)) || '' }}:</span>
              @if (resellerId) {
                <a (click)="getAdminNotes()">{{ 'FIELDS.NOTES_HISTORY' | translate }}</a>
              }
            </lin-form-label>
            <mat-form-field>
              <textarea matInput matTextareaAutosize matAutosizeMinRows="6" matAutosizeMaxRows="6" formControlName="adminNote"></textarea>
              <mat-error>
                <lin-form-field-error [control]="form.get('adminNote')" controlName="adminNote"></lin-form-field-error>
              </mat-error>
            </mat-form-field>
          }
        }
      </lin-layout-form-section>
    </lin-layout-form-sections-wrapper>

    <lin-layout-form-toolbar>
      @if (hasPermission(PermissionType.ResellerNew)) {
        <lin-form-submit-button [isLoading]="isSubmitting" data-testid="btn-save">
          {{ 'BUTTONS.SAVE' | translate }}
        </lin-form-submit-button>
      }

      @if (reseller) {
        <lin-layout-form-toolbar-info>
          <lin-layout-form-toolbar-info-row>
            <lin-layout-form-toolbar-info-label>{{ 'MAIN.CREATED' | translate }}:</lin-layout-form-toolbar-info-label>
            <lin-layout-form-toolbar-info-value>
              {{ (reseller.createdAt | dayjsDateTime) || '-' }} {{ reseller.updatedBy && ('ADMIN.CLIENTS.BY' | translate) }} {{
              reseller.createdByName }}
            </lin-layout-form-toolbar-info-value>
          </lin-layout-form-toolbar-info-row>

          <lin-layout-form-toolbar-info-row>
            <lin-layout-form-toolbar-info-label>{{ 'MAIN.LAST_UPDATED' | translate }}:</lin-layout-form-toolbar-info-label>
            <lin-layout-form-toolbar-info-value>
              {{ (reseller.updatedAt | dayjsDateTime) || '-' }} {{ reseller.updatedBy && ('ADMIN.CLIENTS.BY' | translate) }} {{
              reseller.updatdeByFullName }}
            </lin-layout-form-toolbar-info-value>
          </lin-layout-form-toolbar-info-row>
        </lin-layout-form-toolbar-info>
      }
    </lin-layout-form-toolbar>
  </form>
}
